module.exports = __webpack_public_path__ + "ce2470a71171c2db3c7b3e5a9e3329b8.jpg";